




import Vue from 'vue'

export default Vue.extend({
  name: 'Logout',
  mounted () {
    this.$store.direct.dispatch.user.logoutUser().then(() => {
      this.$router.push({ name: 'login' }).catch(error => {
        console.info(`Ignoring error ${error} while logging out`)
      })
    }).catch(error => {
      console.error('Error during logout ', error)
    })
  }
})
